<template>
  <div :class="componentClassName">
    <a-page-heading>企業情報管理</a-page-heading>
    <m-section>
      <m-action-card title="企業情報追加" icon="user" :header-border="true" :narrow-body="true">
        <div class="m-user-invitation-upload-radio__button">
          <a-button
            id="handleTemplateDownloadClickBtn"
            variant="text"
            color="primary"
            :href="templateUrl"
            @click="handleTemplateDownloadClick"
          >
            テンプレートをダウンロード <a-icon icon="download" color="orange" />
          </a-button>
        </div>
        <a-upload-field
          id="uploadArea"
          v-model="file"
          class="t-settings-companys-add__form-upload"
          accept=".csv,.CSV"
          @change="handleUploadFileChange"
        />
        <div style="clear: both"></div>

        <form ref="form" class="t-settings-companys-add__form" @submit.prevent="handleFormSubmit">
          <div v-if="companyInfoData" class="t-settings-companys-add__fields">
            <m-form-input label="対象サービス">
              <a-select-field
                v-model="voicedxOnlyFlagView"
                class="a-business-hour-input-field__start"
                :options="voiceDXLinkingOptions"
                :show-arrow="true"
                :disabled="true"
              />
            </m-form-input>
            <!-- // #3895 企業追加処理から申し込み処理に変更するに伴い企業ID発番処理を削除
            <m-form-input label="契約ID（必須）">
              <a-text-field v-model="companyInfoData.companyID" type="text" />
            </m-form-input>
            -->
            <m-form-input label="顧客ID">
              <a-text-field
                id="customerID"
                v-model="companyInfoData.customerID"
                maxlength="10"
                pattern="[0-9a-zA-Z]+"
                type="text"
              />
            </m-form-input>
            <m-form-input label="個人名義・法人名義（必須）">
              <a-select-field
                id="businessType"
                v-model="companyInfoData.businessType"
                placeholder="選択してください"
                :options="businessTypeList"
              />
            </m-form-input>
            <m-form-input label="取引種別">
              <a-select-field
                id="inPersonTransactionFlag"
                v-model="companyInfoData.inPersonTransactionFlag"
                class="a-business-hour-input-field__start"
                :options="inPersonTransactionFlagList"
                :show-arrow="true"
                :disabled="voicedxOnlyFlagView !== 'true'"
              />
            </m-form-input>

            <br />
            <p>法人情報</p>
            <m-form-input label="契約名義">
              <a-text-field
                id="companyName"
                v-model="companyInfoData.companyName"
                type="text"
                placeholder="入力してください"
                maxlength="40"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="契約名義カナ">
              <a-text-field
                id="companyKanaName"
                v-model="companyInfoData.companyKanaName"
                type="text"
                placeholder="全角カタカナ"
                maxlength="40"
                pattern="[ァ-ヶー 　]+"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="郵便番号">
              <a-text-field
                id="companyPostCode"
                v-model="companyInfoData.companyPostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-select-field
                id="-address1"
                v-model="companyInfoData.companyAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="市区町村">
              <a-text-field
                id="companyAddress2"
                v-model="companyInfoData.companyAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field
                id="companyAddress3"
                v-model="companyInfoData.companyAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="companyAddress4"
                v-model="companyInfoData.companyAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="事業内容">
              <a-text-field
                id="companyBusinessDetails"
                v-model="companyInfoData.companyBusinessDetails"
                type="text"
                placeholder="入力してください"
                maxlength="100"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="法人番号">
              <a-text-field
                id="companyNumber"
                v-model="companyInfoData.companyNumber"
                type="text"
                placeholder=""
                maxlength="13"
                pattern="[0-9]+"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の有無">
              <a-radio
                id="radio-false"
                v-model="radio"
                name="flag"
                value="false"
                label="無"
                :disabled="companyInfoData.businessType !== 'company'"
              />
              <a-radio
                id="radio-true"
                v-model="radio"
                name="flag"
                value="true"
                label="有"
                :disabled="companyInfoData.businessType !== 'company'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名">
              <a-text-field
                id="companyRulerName"
                v-model="companyInfoData.companyRulerName"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所">
              <a-text-field
                id="companyRulerAddress"
                v-model="companyInfoData.companyRulerAddress"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日">
              <a-text-field
                id="companyRulerBirthDate"
                v-model="companyInfoData.companyRulerBirthDate"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係">
              <a-text-field
                id="companyRelationship"
                v-model="companyInfoData.companyRelationship"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名2">
              <a-text-field
                id="companyRulerName2"
                v-model="companyInfoData.companyRulerName2"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所2">
              <a-text-field
                id="companyRulerAddress2"
                v-model="companyInfoData.companyRulerAddress2"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日2">
              <a-text-field
                id="companyRulerBirthDate2"
                v-model="companyInfoData.companyRulerBirthDate2"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係2">
              <a-text-field
                id="companyRelationship2"
                v-model="companyInfoData.companyRelationship2"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名3">
              <a-text-field
                id="companyRulerName3"
                v-model="companyInfoData.companyRulerName3"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所3">
              <a-text-field
                id="companyRulerAddress3"
                v-model="companyInfoData.companyRulerAddress3"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日3">
              <a-text-field
                id="companyRulerBirthDate3"
                v-model="companyInfoData.companyRulerBirthDate3"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係3">
              <a-text-field
                id="companyRelationship3"
                v-model="companyInfoData.companyRelationship3"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名4">
              <a-text-field
                id="companyRulerName4"
                v-model="companyInfoData.companyRulerName4"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所4">
              <a-text-field
                id="companyRulerAddress4"
                v-model="companyInfoData.companyRulerAddress4"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日4">
              <a-text-field
                id="companyRulerBirthDate4"
                v-model="companyInfoData.companyRulerBirthDate4"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係4">
              <a-text-field
                id="companyRelationship4"
                v-model="companyInfoData.companyRelationship4"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="companyInfoData.businessType !== 'company' || radio !== 'true'"
              />
            </m-form-input>

            <br />
            <p>マスタ管理者</p>
            <m-form-input label="氏名（必須）">
              <a-text-field
                id="adminLastName"
                v-model="companyInfoData.adminLastName"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
              />
              <a-text-field
                id="adminName"
                v-model="companyInfoData.adminName"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
              />
            </m-form-input>
            <m-form-input label="氏名カナ（必須）">
              <a-text-field
                id="adminLastKanaName"
                v-model="companyInfoData.adminLastKanaName"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
              />
              <a-text-field
                id="adminKanaName"
                v-model="companyInfoData.adminKanaName"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
              />
            </m-form-input>
            <m-form-input label="生年月日（必須）">
              <a-text-field
                id="adminBirthDate"
                v-model="companyInfoData.adminBirthDate"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                required
              />
            </m-form-input>
            <m-form-input label="メールアドレス（必須）">
              <a-text-field
                id="adminEmail"
                v-model="companyInfoData.adminEmail"
                type="email"
                placeholder="キャリアメールは使えません"
                maxlength="50"
                required
              />
            </m-form-input>
            <m-form-input label="職業（必須）">
              <a-select-field
                id="-job"
                v-model="companyInfoData.adminJob"
                required
                :options="jobs"
                :tabopen="tabopen"
              />
            </m-form-input>
            <m-form-input label="電話番号（必須）">
              <a-text-field
                id="adminPhoneNumber"
                v-model="companyInfoData.adminPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                required
              />
            </m-form-input>
            <m-form-input label="郵便番号（必須）">
              <a-text-field
                id="adminPostCode"
                v-model="companyInfoData.adminPostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                required
              />
            </m-form-input>
            <m-form-input label="都道府県名（必須）">
              <a-select-field
                id="-adminaddress1"
                v-model="companyInfoData.adminAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
              />
            </m-form-input>
            <m-form-input label="市区町村（必須）">
              <a-text-field
                id="adminAddress2"
                v-model="companyInfoData.adminAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など（必須）">
              <a-text-field
                id="adminAddress3"
                v-model="companyInfoData.adminAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="adminAddress4"
                v-model="companyInfoData.adminAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
              />
            </m-form-input>

            <br />
            <p>営業担当者情報</p>
            <m-form-input label="販売チャネルコード">
              <a-text-field
                id="masterAdminSalesChannelCode"
                v-model="companyInfoData.salesChannelCode"
                type="text"
                placeholder=""
                maxlength="8"
                pattern="[0-9a-zA-Z]+"
              />
            </m-form-input>
            <m-form-input label="販売担当者コード">
              <a-text-field
                id="masterAdminSalesRepresentativeCode"
                v-model="companyInfoData.salesPersonCode"
                type="text"
                placeholder=""
                maxlength="9"
                pattern="[0-9a-zA-Z]+"
              />
            </m-form-input>
            <m-form-input label="販売担当者氏名（姓名）">
              <a-text-field
                id="salesPerson"
                v-model="companyInfoData.salesPerson"
                type="text"
                placeholder=""
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="販売担当者氏名カナ（姓名）">
              <a-text-field
                id="salesPersonKanaName"
                v-model="companyInfoData.salesPersonKanaName"
                type="text"
                placeholder=""
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="販売担当者組織/部課名">
              <a-text-field
                id="salesPersonDepartment"
                v-model="companyInfoData.salesPersonDepartment"
                type="text"
                placeholder=""
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="販売担当者メールアドレス">
              <a-text-field
                id="salesPersonEmailAddress"
                v-model="companyInfoData.salesPersonEmailAddress"
                type="email"
                placeholder=""
                maxlength="50"
              />
            </m-form-input>
            <m-form-input label="販売担当者電話番号">
              <a-text-field
                id="salesPersonPhoneNumber"
                v-model="companyInfoData.salesPersonPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
              />
            </m-form-input>

            <br />
            <p>お申し込み対応部門</p>
            <m-form-input label="お申し込み受付担当者 氏名（姓名）">
              <a-text-field
                id="signupResponderName"
                v-model="companyInfoData.signupResponderName"
                type="text"
                placeholder=""
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="お申し込み受付担当者 氏名カナ（姓名）">
              <a-text-field
                id="signupResponderNameKana"
                v-model="companyInfoData.signupResponderNameKana"
                type="text"
                placeholder=""
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="お申し込み受付担当者 組織/部課名">
              <a-text-field
                id="signupResponderDepartment"
                v-model="companyInfoData.signupResponderDepartment"
                type="text"
                placeholder=""
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="お申し込み受付担当者 メールアドレス">
              <a-text-field
                id="signupResponderMail"
                v-model="companyInfoData.signupResponderMail"
                type="email"
                placeholder=""
                maxlength="50"
              />
            </m-form-input>
            <m-form-input label="お申し込み受付担当者 電話番号">
              <a-text-field
                id="signupResponderPhoneNumber"
                v-model="companyInfoData.signupResponderPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
              />
            </m-form-input>

            <br />
            <p>ヒアリング事項</p>
            <m-form-input label="取引目的（必須）">
              <div class="a-text-field a-text-field--text" required>
                <textarea
                  id="purposeOfUse"
                  v-model="companyInfoData.purposeOfUse"
                  class="a-text-field__input"
                  placeholder="入力してください"
                  maxlength="100"
                  required
                />
              </div>
            </m-form-input>
            <m-form-input label="利用予定の電話番号数（ご利用開始から1ヶ月間）">
              <a-text-field
                id="expectedNumberOfPhoneNumber"
                v-model="companyInfoData.expectedNumberOfPhoneNumber"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
              />
            </m-form-input>
            <m-form-input label="利用予定の電話番号数の最大値">
              <a-text-field
                id="expectedMaxNumberOfPhoneNumber"
                v-model="companyInfoData.expectedMaxNumberOfPhoneNumber"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
              />
            </m-form-input>
            <m-form-input label="利用予定の電話発信回数（1ヶ月あたり）の最大値">
              <a-text-field
                id="expectedMaxNumberOfOutgoingCalls"
                v-model="companyInfoData.expectedMaxNumberOfOutgoingCalls"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
              />
            </m-form-input>
            <m-form-input label="利用予定の電話着信回数（1ヶ月あたり）の最大値">
              <a-text-field
                id="expectedMaxNumberOfIncomingCalls"
                v-model="companyInfoData.expectedMaxNumberOfIncomingCalls"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
              />
            </m-form-input>
            <m-form-input label="取引時確認書類の確認日時">
              <a-text-field
                id="documentCheckDay"
                v-model="companyInfoData.documentCheckDay"
                type="text"
                placeholder="yyyymmddHHMM"
                maxlength="12"
                pattern="[0-9]{12}"
                :disabled="voicedxOnlyFlagView !== 'true' || !companyInfoData.inPersonTransactionFlag"
              />
            </m-form-input>
            <m-form-input label="「契約に関する責任者連絡先」欄の確認を行った書類">
              <a-select-field
                id="documentType"
                v-model="companyInfoData.documentType"
                class="a-business-hour-input-field__start"
                :options="documentTypeList"
                :show-arrow="true"
                :disabled="voicedxOnlyFlagView !== 'true' || !companyInfoData.inPersonTransactionFlag"
              />
            </m-form-input>
            <m-form-input label="取引の任に当たっていることを確認した方法">
              <a-select-field
                id="inPersonCertificateType"
                v-model="companyInfoData.inPersonCertificateType"
                class="a-business-hour-input-field__start"
                :options="inPersonCertificateTypeList"
                :show-arrow="true"
                :disabled="voicedxOnlyFlagView !== 'true'"
              />
            </m-form-input>

            <br />
            <p>請求書送付先</p>
            <m-form-input label="郵便番号（必須）">
              <a-text-field
                id="invoicePostCode"
                v-model="companyInfoData.invoicePostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
              />
            </m-form-input>
            <m-form-input label="都道府県名（必須）">
              <a-select-field
                id="-invoiceaddress1"
                v-model="companyInfoData.invoiceAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
              />
            </m-form-input>
            <m-form-input label="市区町村（必須）">
              <a-text-field
                id="invoiceAddress2"
                v-model="companyInfoData.invoiceAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など（必須）">
              <a-text-field
                id="invoiceAddress3"
                v-model="companyInfoData.invoiceAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="invoiceAddress4"
                v-model="companyInfoData.invoiceAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
              />
            </m-form-input>
            <m-form-input label="宛名"></m-form-input>
            <div class="a-invoice-padding">
              <m-form-input label="請求書送付先①カナ（必須）">
                <a-text-field
                  id="invoiceKanaName"
                  v-model="companyInfoData.invoiceKanaName"
                  type="text"
                  placeholder="入力してください"
                  maxlength="35"
                />
              </m-form-input>
              <m-form-input label="請求書送付先①（必須）">
                <a-text-field
                  id="invoiceAddCompany"
                  v-model="invoiceNameData.invoiceCompany"
                  type="text"
                  placeholder="入力してください"
                  maxlength="20"
                />
              </m-form-input>
              <m-form-input label="請求書送付先②">
                <a-text-field
                  id="invoiceAddDepartment"
                  v-model="invoiceNameData.invoiceDepartment"
                  type="text"
                  placeholder="ハイフンなし"
                  maxlength="20"
                />
              </m-form-input>
            </div>
            <m-form-input label="電話番号（必須）">
              <a-text-field
                id="invoicePhoneNumber"
                v-model="companyInfoData.invoicePhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
              />
            </m-form-input>

            <br />
            <p>その他</p>
            <m-form-input label="開通希望日">
              <a-text-field
                id="openDay"
                v-model="companyInfoData.openDay"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="voicedxOnlyFlagView !== 'true'"
              />
            </m-form-input>
            <m-form-input label="備考">
              <div class="a-text-field a-text-field--text">
                <textarea
                  id="note"
                  v-model="companyInfoData.note"
                  class="a-text-field__input"
                  placeholder=""
                  maxlength="200"
                />
              </div>
            </m-form-input>
            <m-form-input label="応対者">
              <a-text-field
                id="responderName"
                v-model="companyInfoData.responderName"
                type="text"
                placeholder=""
                maxlength="41"
              />
            </m-form-input>
          </div>
          <m-form-action-buttons>
            <a-button
              v-if="companyInfoData"
              id="handleCompanyAddBtn"
              variant="block"
              color="primary"
              :disabled="!flagSaveButtonEnable"
              @click="handleCompanyAdd"
              >申し込みとして保存</a-button
            >
            <a-button id="handleCancelClickBtn" variant="outlined" color="primary" @click="handleCancelClick"
              >キャンセル</a-button
            >
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingCompanyAdd_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="handleCloseModalBtn"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
// import ACaptionList from '@/components/atoms/caption-list';
import ASelectField from '@/components/atoms/select-field';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';
import { PREFECTURES } from '@/libs/constants';
import { JOBS } from '@/libs/constants';

export default {
  name: 't-setting-companys-add',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormActionButtons,
    MFormInput,
    ATextField,
    // ACaptionList,
    ASelectField,
  },
  mixins: [customRequest, customValidate],
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.initialize();
    });
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
    templateUrl: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      companyInfoData: {
        voicedxOnlyFlag: true,
        companyID: '',
        customerID: '',
        businessType: 'individual',
        companyName: '',
        companyKanaName: '',
        companyPostCode: '',
        companyAddress1: '',
        companyAddress2: '',
        companyAddress3: '',
        companyAddress4: '',
        companyBusinessDetails: '',
        companyNumber: '',
        companyRulerFlag: true,
        companyRulerName: '',
        companyRulerAddress: '',
        companyRulerBirthDate: '',
        companyRelationship: '',
        companyRulerName2: '',
        companyRulerAddress2: '',
        companyRulerBirthDate2: '',
        companyRelationship2: '',
        companyRulerName3: '',
        companyRulerAddress3: '',
        companyRulerBirthDate3: '',
        companyRelationship3: '',
        companyRulerName4: '',
        companyRulerAddress4: '',
        companyRulerBirthDate4: '',
        companyRelationship4: '',
        salesChannelCode: '',
        salesPersonCode: '',
        salesPerson: '',
        salesPersonKanaName: '',
        salesPersonEmailAddress: '',
        salesPersonPhoneNumber: '',
        salesPersonDepartment: '',
        expectedNumberOfPhoneNumber: '',
        expectedMaxNumberOfPhoneNumber: '',
        expectedMaxNumberOfOutgoingCalls: '',
        expectedMaxNumberOfIncomingCalls: '',
        adminLastName: '',
        adminName: '',
        adminLastKanaName: '',
        adminKanaName: '',
        adminBirthDate: '',
        adminEmail: '',
        adminJob: '',
        adminPhoneNumber: '',
        adminPostCode: '',
        adminAddress1: '',
        adminAddress2: '',
        adminAddress3: '',
        adminAddress4: '',
        purposeOfUse: '',
        invoicePostCode: '',
        invoiceAddress1: '',
        invoiceAddress2: '',
        invoiceAddress3: '',
        invoiceAddress4: '',
        invoiceName: '',
        invoiceKanaName: '',
        invoicePhoneNumber: '',
        signupResponderName: '',
        signupResponderNameKana: '',
        signupResponderMail: '',
        signupResponderPhoneNumber: '',
        signupResponderDepartment: '',
        inPersonTransactionFlag: '',
        inPersonCertificateType: '',
        documentCheckDay: '',
        documentType: '',
        note: '',
        openDay: '',
        billType: '請求書払い',
        contractStatus: '',
        soStatus: '',
        responderName: '',
      },
      companyInfo: {},
      //companyList: [],
      //companyIDList: [],
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      devCompanyIDPrefixes: ['003', '004', '005'],
      isCreate: false,
      isUpdate: false,
      projectEnv: '',
      voiceDXLinkingOptions: [
        { label: 'COTOHA Voice DX Basicのみ', value: 'true' },
        { label: 'COTOHA Voice DX Basic・COTOHA Call Center共用', value: 'false' },
      ],
      inPersonTransactionFlagList: [
        { label: '対面取引', value: true },
        { label: '非対面取引', value: false },
      ],
      businessTypeList: [
        {
          value: 'individual',
          label: '個人',
        },
        {
          value: 'company',
          label: '法人',
        },
      ],
      documentTypeList: [
        { label: '運転免許証', value: 'driverLicense' },
        { label: 'マイナンバーカード', value: 'myNumberCard' },
      ],
      inPersonCertificateTypeList: [
        {
          label: 'NTTコム営業担当者が「ビデオや電話会議または対面での会議」での協議にて、口頭で確認済み',
          value: 'salesPersonCheck',
        },
        { label: 'NTTコム営業担当者が委任状を目視にて確認済み', value: 'letterOfCommission' },
        { label: 'NTTコム営業担当者に委任状の写しをメールで提出', value: 'letterOfCommissionCopy' },
      ],
      radio: '',
      voicedxOnlyFlagView: 'true',
      flagSaveButtonEnable: true, //#1892
      // #2456
      spCharCheckListEveryTime: [
        /*
        {
          name: '契約ID',
          fieldName: 'companyID',
        },
        */
        {
          name: '顧客ID',
          fieldName: 'customerID',
        },
        {
          name: '取引種別',
          fieldName: 'inPersonTransactionFlag',
        },
      ],
      spCharCheckListCompany: [
        {
          name: '法人情報.契約名義',
          fieldName: 'companyName',
        },
        {
          name: '法人情報.契約名義カナ',
          fieldName: 'companyKanaName',
        },
        {
          name: '法人情報.郵便番号',
          fieldName: 'companyPostCode',
        },
        {
          name: '法人情報.都道府県名',
          fieldName: 'companyAddress1',
        },
        {
          name: '法人情報.市区町村',
          fieldName: 'companyAddress2',
        },
        {
          name: '法人情報.字丁目番地など',
          fieldName: 'companyAddress3',
        },
        {
          name: '法人情報.住所建物など',
          fieldName: 'companyAddress4',
        },
        {
          name: '法人情報.事業内容',
          fieldName: 'companyBusinessDetails',
        },
        {
          name: '法人情報.法人番号',
          fieldName: 'companyNumber',
        },
      ],
      spCharCheckListRuler: [
        {
          name: '法人情報.実質的支配者名',
          fieldName: 'companyRulerName',
        },
        {
          name: '法人情報.実質的支配者住所',
          fieldName: 'companyRulerAddress',
        },
        {
          name: '法人情報.実質的支配者生年月日',
          fieldName: 'companyRulerBirthDate',
        },
        {
          name: '法人情報.実質的支配者の法人との関係',
          fieldName: 'companyRelationship',
        },
        {
          name: '法人情報.実質的支配者名2',
          fieldName: 'companyRulerName2',
        },
        {
          name: '法人情報.実質的支配者住所2',
          fieldName: 'companyRulerAddress2',
        },
        {
          name: '法人情報.実質的支配者生年月日2',
          fieldName: 'companyRulerBirthDate2',
        },
        {
          name: '法人情報.実質的支配者の法人との関係2',
          fieldName: 'companyRelationship2',
        },
        {
          name: '法人情報.実質的支配者名3',
          fieldName: 'companyRulerName3',
        },
        {
          name: '法人情報.実質的支配者住所3',
          fieldName: 'companyRulerAddress3',
        },
        {
          name: '法人情報.実質的支配者生年月日3',
          fieldName: 'companyRulerBirthDate3',
        },
        {
          name: '法人情報.実質的支配者の法人との関係3',
          fieldName: 'companyRelationship3',
        },
        {
          name: '法人情報.実質的支配者名4',
          fieldName: 'companyRulerName4',
        },
        {
          name: '法人情報.実質的支配者住所4',
          fieldName: 'companyRulerAddress4',
        },
        {
          name: '法人情報.実質的支配者生年月日4',
          fieldName: 'companyRulerBirthDate4',
        },
        {
          name: '法人情報.実質的支配者の法人との関係4',
          fieldName: 'companyRelationship4',
        },
      ],
      spCharCheckList: [
        {
          name: 'マスタ管理者.氏名',
          fieldName: 'adminLastName',
        },
        {
          name: 'マスタ管理者.氏名',
          fieldName: 'adminName',
        },
        {
          name: 'マスタ管理者.氏名カナ',
          fieldName: 'adminLastKanaName',
        },
        {
          name: 'マスタ管理者.氏名カナ',
          fieldName: 'adminKanaName',
        },
        {
          name: 'マスタ管理者.生年月日',
          fieldName: 'adminBirthDate',
        },
        {
          name: 'マスタ管理者.メールアドレス',
          fieldName: 'adminEmail',
        },
        {
          name: 'マスタ管理者.職業',
          fieldName: 'adminJob',
        },
        {
          name: 'マスタ管理者.電話番号',
          fieldName: 'adminPhoneNumber',
        },
        {
          name: 'マスタ管理者.郵便番号',
          fieldName: 'adminPostCode',
        },
        {
          name: 'マスタ管理者.都道府県名',
          fieldName: 'adminAddress1',
        },
        {
          name: 'マスタ管理者.市区町村',
          fieldName: 'adminAddress2',
        },
        {
          name: 'マスタ管理者.字丁目番地など',
          fieldName: 'adminAddress3',
        },
        {
          name: 'マスタ管理者.住所建物など',
          fieldName: 'adminAddress4',
        },
      ],
      spCharCheckListSalesPerson: [
        { name: '営業担当者情報.販売チャネルコード', fieldName: 'salesChannelCode' },
        { name: '営業担当者情報.販売担当者コード', fieldName: 'salesPersonCode' },
        { name: '営業担当者情報.販売担当者氏名（姓名）', fieldName: 'salesPerson' },
        { name: '営業担当者情報.販売担当者氏名カナ（姓名）', fieldName: 'salesPersonKanaName' },
        { name: '営業担当者情報.販売担当者組織/部課名', fieldName: 'salesPersonDepartment' },
        { name: '営業担当者情報.販売担当者メールアドレス', fieldName: 'salesPersonEmailAddress' },
        { name: '営業担当者情報.販売担当者電話番号', fieldName: 'salesPersonPhoneNumber' },
      ],
      spCharCheckListSignupResponder: [
        { name: 'お申し込み対応部門.お申し込み受付担当者 氏名（姓名）', fieldName: 'signupResponderName' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 氏名カナ（姓名）', fieldName: 'signupResponderNameKana' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 組織/部課名', fieldName: 'signupResponderDepartment' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 メールアドレス', fieldName: 'signupResponderMail' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 電話番号', fieldName: 'signupResponderPhoneNumber' },
      ],
      spCharCheckListHearing: [
        { name: 'ヒアリング事項.取引目的', fieldName: 'purposeOfUse' },
        {
          name: 'ヒアリング事項.利用予定の電話番号数（ご利用開始から1ヶ月間）',
          fieldName: 'expectedNumberOfPhoneNumber',
        },
        {
          name: 'ヒアリング事項.利用予定の電話番号数の最大値',
          fieldName: 'expectedMaxNumberOfPhoneNumber',
        },
        {
          name: 'ヒアリング事項.利用予定の電話発信回数（1ヶ月あたり）の最大値',
          fieldName: 'expectedMaxNumberOfOutgoingCalls',
        },
        {
          name: 'ヒアリング事項.利用予定の電話着信回数（1ヶ月あたり）の最大値',
          fieldName: 'expectedMaxNumberOfIncomingCalls',
        },
        { name: 'ヒアリング事項.取引時確認書類の確認日時', fieldName: 'documentCheckDay' },
        { name: 'ヒアリング事項.「契約に関する責任者連絡先」欄の確認を行った書類', fieldName: 'documentType' },
        { name: 'ヒアリング事項.取引の任に当たっていることを確認した方法', fieldName: 'inPersonCertificateType' },
      ],
      spCharCheckAddressInvoice: [
        {
          name: '請求書送付先①',
          fieldName: 'invoiceCompany',
        },
        {
          name: '請求書送付先②',
          fieldName: 'invoiceDepartment',
        },
      ],
      spCharCheckListInvoice: [
        {
          name: '請求書送付先.郵便番号',
          fieldName: 'invoicePostCode',
        },
        {
          name: '請求書送付先.都道府県名',
          fieldName: 'invoiceAddress1',
        },
        {
          name: '請求書送付先.市区町村',
          fieldName: 'invoiceAddress2',
        },
        {
          name: '請求書送付先.字丁目番地など',
          fieldName: 'invoiceAddress3',
        },
        {
          name: '請求書送付先.住所建物など',
          fieldName: 'invoiceAddress4',
        },
        {
          name: '請求書送付先.送付先名',
          fieldName: 'invoiceName',
        },
        {
          name: '請求書送付先.送付先名カナ',
          fieldName: 'invoiceKanaName',
        },
        {
          name: '請求書送付先.電話番号',
          fieldName: 'invoicePhoneNumber',
        },
      ],
      spCharCheckListOther: [
        {
          name: 'その他.開通希望日',
          fieldName: 'openDay',
        },
        {
          name: 'その他.備考',
          fieldName: 'note',
        },
        {
          name: 'その他.応対者',
          fieldName: 'responderName',
        },
      ],
      prefectures: [],
      jobs: [],
      invoiceNameData: {
        invoiceCompany: '',
        invoiceDepartment: '',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-company-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    this.prefectures = PREFECTURES;
    this.jobs = JOBS;
  },
  methods: {
    initialize: function () {
      if (this.companyID !== POINT || this.authInfo === 'operator') {
        this.$router.push({ path: '/permission-denied' });
      }
      // #3895 企業追加処理から申し込み処理に変更するに伴い企業ID発番処理を削除
      //this.handlerFetchCompanyData();
      this.handlerFetchProjectEnv();
      this.companyInfoData.responderName = this.username;
    },
    handlerFetchProjectEnv: function () {
      // 適当なAPIを利用してenvを取得
      this.postRequest('/companymgmt/getinitdata')
        .then(e => {
          if (e.status === 'success') {
            this.projectEnv = e.projectEnv;
          } else {
            this.showErrorModal(messageContent.requireTry('環境情報の取得'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('環境情報の取得'));
        });
    },
    /*
    handlerFetchCompanyData: function () {
      this.postRequest('/companymgmt/getinitdata')
        .then(e => {
          if (e.status === 'success') {
            this.companyList = e.data;
            const companyIDList = [];
            for (let i = 0; i < e.data.length; i++) {
              companyIDList.push(e.data[i].companyID);
            }
            this.projectEnv = e.projectEnv;
            this.companyIDList = companyIDList;
            this.generateCompanyID(this.projectEnv);
          } else {
            this.showErrorModal(messageContent.requireTry('企業情報の取得'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('企業情報の取得'));
        });
    },
    */
    handleFormSubmit(event) {
      event.preventDefault();
      this.handleCompanyAdd(cloneDeep(this.companyInfoData));
    },
    /*
    checkUniqueCompanyID() {
      const companyIDList = this.companyIDList;
      if (companyIDList.includes(this.companyInfoData.companyID)) {
        return false;
      } else {
        return true;
      }
    },
    generateCompanyID(projectEnv) {
      const devCompanyIDPrefixes = this.devCompanyIDPrefixes;
      const companyIDList = this.companyIDList;

      let unique = false;
      let numstr = '';
      if (projectEnv === 'production') {
        while (!unique) {
          numstr = this.randomNumStr(6);
          const numstrPrefix = numstr.slice(0, 3);
          if (devCompanyIDPrefixes.includes(numstrPrefix) || companyIDList.includes(numstr)) {
            unique = false;
            numstr = '';
          } else {
            unique = true;
          }
        }
      } else {
        while (!unique) {
          const numstr1 = devCompanyIDPrefixes[Math.floor(Math.random() * devCompanyIDPrefixes.length)];
          const numstr2 = this.randomNumStr(3);
          numstr = numstr1 + numstr2;
          if (companyIDList.includes(numstr)) {
            unique = false;
            numstr = '';
          } else {
            unique = true;
          }
        }
      }
      this.companyInfoData.companyID = numstr;
    },
    */
    // 入力パラメータのチェックを行う。チェックエラーの場合、エラー文言を返す。正常の場合はnullを返す。
    checkInputParameter() {
      /*
      // 企業IDのユニークチェック
      const companyIDCheck = this.checkUniqueCompanyID();
      if (!companyIDCheck) {
        return messageContent.contractIDInUse;
      }
      */

      // 実質的支配者の有無選択チェック
      if (this.companyInfoData.businessType === 'company' && this.radio === '') {
        return messageContent.requireBeneficialOwner;
      }

      // #3981 取引種別の選択は任意項目に修正
      /* // 取引種別の選択チェック
      if (this.companyInfoData.voicedxOnlyFlag && this.companyInfoData.inPersonTransactionFlag === '') {
        return messageContent.requireinPersonTransactionFlag;
      }
      */

      // 特殊記号のチェック：基本項目
      for (const item of this.spCharCheckListEveryTime) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      if (this.companyInfoData.businessType === 'company') {
        // 特殊記号のチェック：法人情報
        for (const item of this.spCharCheckListCompany) {
          if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
            return item.name + 'に' + messageContent.hasSpecialCharacter;
          }
        }
        // 特殊記号のチェック：実質的支配者の情報
        if (this.companyInfoData.companyRulerFlag === true) {
          for (const item of this.spCharCheckListRuler) {
            if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
              return item.name + 'に' + messageContent.hasSpecialCharacter;
            }
          }
        }
      }
      // 特殊記号のチェック：マスタ管理者
      for (const item of this.spCharCheckList) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName].replace(/\r?\n/g, '') })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：営業担当者情報
      for (const item of this.spCharCheckListSalesPerson) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：お申し込み対応部門
      for (const item of this.spCharCheckListSignupResponder) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：ヒアリング事項
      for (const item of this.spCharCheckListHearing) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：請求書情報
      for (const item of this.spCharCheckListInvoice) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：その他
      for (const item of this.spCharCheckListOther) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName].replace(/\r?\n/g, '') })) {
          return item.name + 'に' + messageContent.hasSpecialCharacter;
        }
      }
      // 特殊記号のチェック：請求書送付先①②
      for (const item of this.spCharCheckAddressInvoice) {
        if (
          this.hasSpecialCharacterInObjectInvoice({
            keyWord: this.invoiceNameData[item.fieldName].replace(/\r?\n/g, ''),
          })
        ) {
          return item.name + 'に' + messageContent.hasSpecialCharacterInvoiceName;
        }
      }
      return null;
    },
    handleCompanyAdd() {
      /*
      // 実行する企業ID、及び実行環境のチェック
      const envCheck = this.envCheck();
      if (!envCheck) {
        this.showErrorModal(messageContent.contractIDProhibited);
        return;
      }
      */

      //「請求書送付先①」と「請求書送付先②」から送付先名に変換する
      if (!this.invoiceNameData.invoiceDepartment) {
        this.companyInfoData.invoiceName = this.invoiceNameData.invoiceCompany;
      } else {
        this.companyInfoData.invoiceName =
          this.invoiceNameData.invoiceCompany + '／' + this.invoiceNameData.invoiceDepartment;
      }
      if (!this.invoiceNameData.invoiceCompany) {
        this.companyInfoData.invoiceName = '';
      }

      // 入力パラメータのチェック
      const resultParameterCheck = this.checkInputParameter();
      if (resultParameterCheck) {
        this.showErrorModal(resultParameterCheck);
        return;
      }

      const adminBirthDate = this.companyInfoData.adminBirthDate;
      let y = adminBirthDate.substr(0, 4);
      let m = adminBirthDate.substr(4, 2);
      let d = adminBirthDate.substr(6);
      const value = y + '-' + m + '-' + d;

      let companyRulerNo = '';
      const setCompanyInfoData = [];
      for (let i = 0; i < 4; i++) {
        if (i > 0) {
          companyRulerNo = String(i + 1);
        }
        const companyRulerBirthDate = this.companyInfoData['companyRulerBirthDate' + companyRulerNo];
        if (companyRulerBirthDate !== '' && typeof companyRulerBirthDate !== 'undefined') {
          const y = companyRulerBirthDate.substr(0, 4);
          const m = companyRulerBirthDate.substr(4, 2);
          const d = companyRulerBirthDate.substr(6);
          setCompanyInfoData[i + 1] = y + '-' + m + '-' + d;
        } else {
          setCompanyInfoData[i + 1] = '';
        }
      }

      // 開通希望日の更新(voicedxOnlyFlagがfalseの際にopenDayを空にする処理を含む)
      let value3 = '';
      if (this.voicedxOnlyFlagView === 'true') {
        const openDay = this.companyInfoData.openDay;
        if (openDay !== '') {
          y = openDay.substr(0, 4);
          m = openDay.substr(4, 2);
          d = openDay.substr(6);
          value3 = y + '-' + m + '-' + d;
        }
      }

      // 登録するデータの作成
      const sendData = {
        voicedxOnlyFlag: this.voicedxOnlyFlagView === 'true' ? true : false,
        //newCompanyID: this.companyInfoData.companyID,
        customerID: this.companyInfoData.customerID ? this.companyInfoData.customerID : '',
        companyName: this.companyInfoData.companyName ? this.companyInfoData.companyName : '',
        companyKanaName: this.companyInfoData.companyKanaName ? this.companyInfoData.companyKanaName : '',
        companyPostCode: this.companyInfoData.companyPostCode ? this.companyInfoData.companyPostCode : '',
        companyAddress1: this.companyInfoData.companyAddress1 ? this.companyInfoData.companyAddress1 : '',
        companyAddress2: this.companyInfoData.companyAddress2 ? this.companyInfoData.companyAddress2 : '',
        companyAddress3: this.companyInfoData.companyAddress3 ? this.companyInfoData.companyAddress3 : '',
        companyAddress4: this.companyInfoData.companyAddress4 ? this.companyInfoData.companyAddress4 : '',
        companyBusinessDetails: this.companyInfoData.companyBusinessDetails
          ? this.companyInfoData.companyBusinessDetails
          : '',
        companyNumber: this.companyInfoData.companyNumber ? this.companyInfoData.companyNumber : '',
        companyRulerFlag: this.radio === 'true' ? true : false,
        companyRulerName: this.companyInfoData.companyRulerName ? this.companyInfoData.companyRulerName : '',
        companyRulerAddress: this.companyInfoData.companyRulerAddress ? this.companyInfoData.companyRulerAddress : '',
        companyRulerBirthDate: setCompanyInfoData[1],
        companyRelationship: this.companyInfoData.companyRelationship ? this.companyInfoData.companyRelationship : '',
        companyRulerName2: this.companyInfoData.companyRulerName2 ? this.companyInfoData.companyRulerName2 : '',
        companyRulerAddress2: this.companyInfoData.companyRulerAddress2
          ? this.companyInfoData.companyRulerAddress2
          : '',
        companyRulerBirthDate2: setCompanyInfoData[2],
        companyRelationship2: this.companyInfoData.companyRelationship2
          ? this.companyInfoData.companyRelationship2
          : '',
        companyRulerName3: this.companyInfoData.companyRulerName3 ? this.companyInfoData.companyRulerName3 : '',
        companyRulerAddress3: this.companyInfoData.companyRulerAddress3
          ? this.companyInfoData.companyRulerAddress3
          : '',
        companyRulerBirthDate3: setCompanyInfoData[3],
        companyRelationship3: this.companyInfoData.companyRelationship3
          ? this.companyInfoData.companyRelationship3
          : '',
        companyRulerName4: this.companyInfoData.companyRulerName4 ? this.companyInfoData.companyRulerName4 : '',
        companyRulerAddress4: this.companyInfoData.companyRulerAddress4
          ? this.companyInfoData.companyRulerAddress4
          : '',
        companyRulerBirthDate4: setCompanyInfoData[4],
        companyRelationship4: this.companyInfoData.companyRelationship4
          ? this.companyInfoData.companyRelationship4
          : '',
        adminLastName: this.companyInfoData.adminLastName ? this.companyInfoData.adminLastName : '',
        adminName: this.companyInfoData.adminName ? this.companyInfoData.adminName : '',
        adminLastKanaName: this.companyInfoData.adminLastKanaName ? this.companyInfoData.adminLastKanaName : '',
        adminKanaName: this.companyInfoData.adminKanaName ? this.companyInfoData.adminKanaName : '',
        adminBirthDate: value,
        adminEmail: this.companyInfoData.adminEmail ? this.companyInfoData.adminEmail : '',
        adminJob: this.companyInfoData.adminJob ? this.companyInfoData.adminJob : '',
        adminPhoneNumber: this.companyInfoData.adminPhoneNumber ? this.companyInfoData.adminPhoneNumber : '',
        adminPostCode: this.companyInfoData.adminPostCode ? this.companyInfoData.adminPostCode : '',
        adminAddress1: this.companyInfoData.adminAddress1 ? this.companyInfoData.adminAddress1 : '',
        adminAddress2: this.companyInfoData.adminAddress2 ? this.companyInfoData.adminAddress2 : '',
        adminAddress3: this.companyInfoData.adminAddress3 ? this.companyInfoData.adminAddress3 : '',
        adminAddress4: this.companyInfoData.adminAddress4 ? this.companyInfoData.adminAddress4 : '',
        purposeOfUse: this.companyInfoData.purposeOfUse
          ? this.companyInfoData.purposeOfUse.replace(/\n/g, '%%n%%')
          : '', // #2138
        invoicePostCode: this.companyInfoData.invoicePostCode ? this.companyInfoData.invoicePostCode : '',
        invoiceAddress1: this.companyInfoData.invoiceAddress1 ? this.companyInfoData.invoiceAddress1 : '',
        invoiceAddress2: this.companyInfoData.invoiceAddress2 ? this.companyInfoData.invoiceAddress2 : '',
        invoiceAddress3: this.companyInfoData.invoiceAddress3 ? this.companyInfoData.invoiceAddress3 : '',
        invoiceAddress4: this.companyInfoData.invoiceAddress4 ? this.companyInfoData.invoiceAddress4 : '',
        invoiceName: this.companyInfoData.invoiceName ? this.companyInfoData.invoiceName : '',
        invoiceKanaName: this.companyInfoData.invoiceKanaName ? this.companyInfoData.invoiceKanaName : '',
        invoicePhoneNumber: this.companyInfoData.invoicePhoneNumber ? this.companyInfoData.invoicePhoneNumber : '',
        businessType: this.companyInfoData.businessType ? this.companyInfoData.businessType : '',
        billType: this.companyInfoData.billType ? this.companyInfoData.billType : '',
        inPersonTransactionFlag: this.companyInfoData.inPersonTransactionFlag,
        inPersonCertificateType: this.companyInfoData.inPersonCertificateType
          ? this.companyInfoData.inPersonCertificateType
          : '',
        documentCheckDay:
          this.companyInfoData.inPersonTransactionFlag && this.companyInfoData.documentCheckDay
            ? this.companyInfoData.documentCheckDay
            : '',
        documentType:
          this.companyInfoData.inPersonTransactionFlag && this.companyInfoData.documentType
            ? this.companyInfoData.documentType
            : '',
        openDay: value3,
        contractStatus: this.companyInfoData.contractStatus ? this.companyInfoData.contractStatus : '',
        soStatus: this.companyInfoData.soStatus ? this.companyInfoData.soStatus : '',
        responderName: this.companyInfoData.responderName ? this.companyInfoData.responderName : this.username,
        note: this.companyInfoData.note ? this.companyInfoData.note.replace(/\n/g, '%%n%%') : '', // #2138
        salesChannelCode: this.companyInfoData.salesChannelCode ? this.companyInfoData.salesChannelCode : '',
        salesPersonCode: this.companyInfoData.salesPersonCode ? this.companyInfoData.salesPersonCode : '',
        salesPerson: this.companyInfoData.salesPerson ? this.companyInfoData.salesPerson : '',
        salesPersonKanaName: this.companyInfoData.salesPersonKanaName ? this.companyInfoData.salesPersonKanaName : '',
        salesPersonEmailAddress: this.companyInfoData.salesPersonEmailAddress
          ? this.companyInfoData.salesPersonEmailAddress
          : '',
        salesPersonPhoneNumber: this.companyInfoData.salesPersonPhoneNumber
          ? this.companyInfoData.salesPersonPhoneNumber
          : '',
        salesPersonDepartment: this.companyInfoData.salesPersonDepartment
          ? this.companyInfoData.salesPersonDepartment
          : '',
        expectedNumberOfPhoneNumber: this.companyInfoData.expectedNumberOfPhoneNumber
          ? this.companyInfoData.expectedNumberOfPhoneNumber
          : '',
        expectedMaxNumberOfPhoneNumber: this.companyInfoData.expectedMaxNumberOfPhoneNumber
          ? this.companyInfoData.expectedMaxNumberOfPhoneNumber
          : '',
        expectedMaxNumberOfOutgoingCalls: this.companyInfoData.expectedMaxNumberOfOutgoingCalls
          ? this.companyInfoData.expectedMaxNumberOfOutgoingCalls
          : '',
        expectedMaxNumberOfIncomingCalls: this.companyInfoData.expectedMaxNumberOfIncomingCalls
          ? this.companyInfoData.expectedMaxNumberOfIncomingCalls
          : '',
        signupResponderName: this.companyInfoData.signupResponderName ? this.companyInfoData.signupResponderName : '',
        signupResponderNameKana: this.companyInfoData.signupResponderNameKana
          ? this.companyInfoData.signupResponderNameKana
          : '',
        signupResponderMail: this.companyInfoData.signupResponderMail ? this.companyInfoData.signupResponderMail : '',
        signupResponderPhoneNumber: this.companyInfoData.signupResponderPhoneNumber
          ? this.companyInfoData.signupResponderPhoneNumber
          : '',
        signupResponderDepartment: this.companyInfoData.signupResponderDepartment
          ? this.companyInfoData.signupResponderDepartment
          : '',
      };
      this.flagSaveButtonEnable = false; //#1892
      // invoiceKanaName required
      sendData.invoiceKanaNameRequired = true;
      this.postRequest('/companymgmt/tmpCreate', { data: sendData })
        .then(e => {
          if (e.status === 'success') {
            this.isCreate = true;
            this.showInfoModal(messageContent.notifyTmpCompanyInfoAdd());
            this.flagSaveButtonEnable = true; //#1892
          } else {
            if (Array.isArray(e.errors)) {
              const errMsg = e.errors.map(e => e.msg).join('<br />');
              this.showErrorModal(errMsg);
            } else {
              this.showErrorModal(messageContent.canNotRegisterCompanyInfo);
            }
            this.flagSaveButtonEnable = true; //#1892
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.canNotRegisterCompanyInfo);
          this.flagSaveButtonEnable = true; //#1892
        });
    },
    handleCancelClick() {
      this.$router.push('/companymgmt');
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.isCreate) {
        this.isCreate = false;
        this.$router.push('/companymgmt');
      }
    },
    randomNumStr(length) {
      const content = '0123456789';
      const cl = content.length;
      let numStr = '';
      for (let i = 0; i < length; i++) {
        numStr += content[Math.floor(Math.random() * cl)];
      }
      return numStr;
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    // checkCharType(input, charType) {
    //   switch (charType) {
    //     case "escape":
    //       return input.match(/^(?=.*[&<>'"]).*$/) ? true : false;
    //     case "companyID":
    //       return input.match(/^[0-9]{6}$/) ? true : false;
    //     case "companyName":
    //       return input.match(/^.{1,40}$/) ? true : false;
    //     case "customerID":
    //       return input.match(/^[a-zA-Z0-9!#$%()*+,.:;=?@[\]^_{}-]{0,20}$/)
    //         ? true
    //         : false;
    //     case "adminDepartment":
    //       return input.match(/^.{1,40}$/) ? true : false;
    //     case "adminName":
    //       return input.match(/^([^\x01-\x7E]|\s){1,20}$/) ? true : false;
    //     case "adminKanaName":
    //       return input.match(/^[\sア-ン゛゜ァ-ォャ-ョー「」、]{1,32}$/)
    //         ? true
    //         : false;
    //     case "adminPhoneNumber":
    //       return input.match(/^[0-9]{10,11}$/) ? true : false;
    //     case "adminEmail":
    //       return input.match(
    //         /^([a-zA-Z0-9])+([a-zA-Z0-9._+-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/
    //       )
    //         ? true
    //         : false;
    //     case "invoicePostCode":
    //       return input.match(/^[0-9]{7}$/) ? true : false;
    //     case "invoiceAddress":
    //       return input.match(/^[^\x01-\x7E]{0,20}$/) ? true : false;
    //     case "invoiceName":
    //       return input.match(/^[^\x01-\x7E]{0,20}$/) ? true : false;
    //     case "invoicePhoneNumber":
    //       return input.match(/^[0-9]{10,11}$/) ? true : false;
    //     case "note":
    //       return input.match(/^.{0,100}$/) ? true : false;
    //     case "space":
    //       return input.match(/^([^\x01-\x7E\s]+)\s+([^\x01-\x7E\s]+)$/) ? true : false;
    //   }
    //   return true;
    // },
    /*
    envCheck() {
      const prefixCheck = this.devCompanyIDPrefixes.some(value =>
        value.includes(this.companyInfoData.companyID.slice(0, 3)) ? true : false
      );
      if ((this.projectEnv === 'production' && !prefixCheck) || (this.projectEnv === 'development' && prefixCheck)) {
        return true;
      } else {
        return false;
      }
    },
    */
    // checkHandler() {
    //   if (
    //     this.checkCharType(this.companyInfoData.companyName, "escape") ||
    //     this.checkCharType(this.companyInfoData.adminDepartment, "escape") ||
    //     this.checkCharType(this.companyInfoData.note, "escape")
    //   ) {
    //     this.showErrorModal("&, <, >, ', \" は全角で入力してください。");
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.companyID, "companyID")) {
    //     this.showErrorModal("契約IDは「数字⽂字列6⽂字」で入力してください。");
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.companyName, "companyName")) {
    //     this.showErrorModal(
    //       "契約企業名は「全半⾓40⽂字以内」で入力してください。"
    //     );
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.customerID, "customerID")) {
    //     this.showErrorModal("顧客IDは「半⾓20⽂字以内」で入力してください。");
    //     return false;
    //   } else if (
    //     this.companyInfoData.adminDepartment &&
    //     !this.checkCharType(this.companyInfoData.adminDepartment, "adminDepartment")
    //   ) {
    //     this.showErrorModal(
    //       "所属部署は「全半⾓40⽂字以内」で入力してください。"
    //     );
    //     return false;
    //   } else if (!(this.checkCharType(this.companyInfoData.adminName, "adminName") &&
    //     this.checkCharType(this.companyInfoData.adminName, "space")))
    //   {
    //     this.showErrorModal(
    //       "マスタ管理者 氏名は「全⾓20⽂字以内 かつ スペース区切り」で入力してください。"
    //     );
    //     return false;
    //   } else if (!(this.checkCharType(this.companyInfoData.adminKanaName, "adminKanaName") &&
    //     this.checkCharType(this.companyInfoData.adminKanaName, "space")))
    //   {
    //     this.showErrorModal(
    //       "カナ氏名は「全⾓カナ32⽂字以内 かつ スペース区切り」で入力してください。"
    //     );
    //     return false;
    //   } else if (
    //     !this.checkCharType(this.companyInfoData.adminPhoneNumber, "adminPhoneNumber")
    //   ) {
    //     this.showErrorModal(
    //       "マスタ管理者 電話番号は「10桁または11桁の数字」で入力してください。"
    //     );
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.adminEmail, "adminEmail")) {
    //     this.showErrorModal("メールアドレスを入力してください。");
    //     return false;
    //   } else if (
    //     this.companyInfoData.invoicePostCode &&
    //     !this.checkCharType(this.companyInfoData.invoicePostCode, "invoicePostCode")
    //   ) {
    //     this.showErrorModal(
    //       "郵便番号はハイフンを含めず「半⾓数字7桁」で入力してください。"
    //     );
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.invoiceAddress1, "invoiceAddress")) {
    //     this.showErrorModal("住所１は「全⾓20⽂字以内」で入力してください。");
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.invoiceAddress2, "invoiceAddress")) {
    //     this.showErrorModal("住所２は「全⾓20⽂字以内」で入力してください。");
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.invoiceAddress3, "invoiceAddress")) {
    //     this.showErrorModal(
    //       "字丁目番地などは「全⾓20⽂字以内」で入力してください。"
    //     );
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.invoiceAddress4, "invoiceAddress")) {
    //     this.showErrorModal(
    //       "住所建物などは「全⾓20⽂字以内」で入力してください。"
    //     );
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.invoiceName, "invoiceName")) {
    //     this.showErrorModal(
    //       "請求書送付先 氏名は「全⾓20⽂字以内」で入力してください。"
    //     );
    //     return false;
    //   } else if (
    //     this.companyInfoData.invoicePhoneNumber &&
    //     !this.checkCharType(this.companyInfoData.invoicePhoneNumber, "invoicePhoneNumber")
    //   ) {
    //     this.showErrorModal(
    //       "請求書送付先 電話番号は「10桁または11桁の数字」で入力してください。"
    //     );
    //     return false;
    //   } else if (
    //     !this.checkCharType(this.companyInfoData.invoiceDepartment, "invoiceAddress")
    //   ) {
    //     this.showErrorModal("部課名は「全⾓20⽂字以内」で入力してください。");
    //     return false;
    //   } else if (!this.checkCharType(this.companyInfoData.note, "note")) {
    //     this.showErrorModal("備考は「全半⾓100⽂字以内」で入力してください。");
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }
    handleUploadFileChange(file) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          const [info, content] = reader.result.split(',');
          vm.binary = content;

          const payload = cloneDeep({
            filename: vm.filename,
            binary: vm.binary,
            size: vm.size,
          });

          vm.postRequest('/companymgmt/setCsvAdddata', {
            payload: payload,
            businessTypeList: vm.businessTypeList,
            inPersonTransactionFlagList: vm.inPersonTransactionFlagList,
            jobs: vm.jobs,
            documentTypeList: vm.documentTypeList,
            inPersonCertificateTypeList: vm.inPersonCertificateTypeList,
          })
            .then(e => {
              if (e.status === 'failed') {
                vm.showErrorModal(e.msg);
              } else {
                vm.companyInfoData = e.data;
                vm.radio = vm.companyInfoData.companyRulerFlag;
                vm.companyInfoData.responderName = vm.username;
                vm.companyInfoData.companyID = '';

                const regex = /^"/;
                const regex2 = /"$/;
                vm.companyInfoData.purposeOfUse = vm.companyInfoData.purposeOfUse
                  .replace(/%%n%%/g, '\n')
                  .trim()
                  .replace(regex, '')
                  .replace(regex2, '');
                vm.companyInfoData.note = vm.companyInfoData.note
                  .replace(/%%n%%/g, '\n')
                  .trim()
                  .replace(regex, '')
                  .replace(regex2, '');
                //「請求書送付先①」と「請求書送付先②」設定
                vm.invoiceNameData.invoiceCompany = e.data.invoiceCompany;
                vm.invoiceNameData.invoiceDepartment = e.data.invoiceDepartment;

                //companyInfoDataに「請求書送付先①」と「請求書送付先②」を削除
                delete vm.invoiceCompany;
                delete vm.invoiceDepartment;

                vm.showInfoModal(e.msg);
              }
            })
            .catch(err => {
              console.log(err);
              vm.showErrorModal(messageContent.requireTry('CSV登録'));
            });
        },
        false
      );
      if (file[0]) {
        vm.filename = file[0].name;
        vm.size = file[0].size;
        reader.readAsDataURL(file[0]);
      } else {
        // clear file content
        vm.file = null;
        vm.binary = null;
        vm.filename = undefined;
        vm.size = undefined;
      }
    },
    handleTemplateDownloadClick() {
      this.postRequest('/companymgmt/template')
        .then(e => {
          const blob = new Blob([e.data], { type: 'text/plain' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.download = 'template.csv';
          a.href = url;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('テンプレートファイル取得'));
        });
    },
  },
};
</script>
